export default {
  state: {
    inProduction: ![
      "fe",
      "local.providertrust.com",
      "vendorproof.test1.dev-providertrust.com",
      "vendorproof.test2.dev-providertrust.com",
      "vendorproof.test3.dev-providertrust.com",
      "app.staging-vendorproof.com",
      "vendorproof.staging.staging-providertrust.com",
      "vendorproof.staging2.staging-providertrust.com",
      "vendorproof.staging.staging.internal",
      "vendorproof.staging2.staging.internal",
      "vendorproof.production.production.internal"
    ].includes(window.location.hostname.toLowerCase())
  },
  getters: {
    inProduction: state => state.inProduction
  }
};
